<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="copyProductForm">
      <div class="field-validation-error"></div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              label="Product name"
              name="productName"
              placeholder="Product name"
              formControlName="productName"
              [control]="copyProductForm.controls['productName']"
              [submitted]="submitted"
              [maxLength]="50"
            ></piqet-angular-common-input>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer extraPadding">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
